export function mapEmissorProductToDisplay(product) {
    return {
        title: product.productName ?? product.productId,
        description: product.productDescription ?? product.productCategoryName ?? '',
        icon: product.productIcon ?? null,
        categoryCode: product.productCategoryCode ?? null,
    };
}
export function mapEmissorCategoriesToProductCategories(categories) {
    return categories.map(category => ({ code: category.code, name: category.name }));
}
export function isEmissorProductDiscountEnabled(products, productId) {
    if (!productId) {
        return true;
    }
    const product = products.find(item => item.productId === productId);
    return product?.productIsDiscountEnable ?? true;
}
